import React from 'react';
import './TitleAndImage.module.scss';

type Props = {
  attributes: any;
  lowTile: boolean;
  inPopup?: boolean;
};

export default function TitleAndImage({ attributes, lowTile, inPopup }: Props) {
  return (
    <div
      styleName={`title-and-image ${inPopup ? 'in-popup' : ''} ${
        lowTile ? 'low-tile' : ''
      }`}
    >
      {attributes.image && (
        <div styleName="image-wrapper">
          <img alt="content" src={`/storage/${attributes.image}`} />
        </div>
      )}
      <h2>{attributes?.title}</h2>
    </div>
  );
}
